import { v4 as uuidv4 } from "uuid";

const toTrimmedString = (value) => String(value ?? "").trim();

const toLowerTrimmedString = (value) => toTrimmedString(value).toLowerCase();

const toFiniteNumber = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};

export const computeNextLibraryBlockOrder = (blockLibrary = []) => {
  if (!Array.isArray(blockLibrary) || blockLibrary.length === 0) {
    return 0;
  }

  return (
    blockLibrary.reduce((maxOrder, entry) => {
      const parsedOrder = toFiniteNumber(entry?.order);
      if (parsedOrder == null) return maxOrder;
      return parsedOrder > maxOrder ? parsedOrder : maxOrder;
    }, -1) + 1
  );
};

export const buildPendingMoveLibraryPayload = ({
  block,
  blockLibrary = [],
  destinationBlockId,
} = {}) => {
  if (!block || typeof block?.uploadToCloudLibrary !== "function") {
    return null;
  }

  const normalizedDestinationBlockId = toLowerTrimmedString(
    destinationBlockId || uuidv4()
  );
  if (!normalizedDestinationBlockId) {
    return null;
  }

  const blockPayload = block.uploadToCloudLibrary();
  if (!blockPayload || typeof blockPayload !== "object") {
    return null;
  }

  return {
    ...blockPayload,
    id: normalizedDestinationBlockId,
    order: computeNextLibraryBlockOrder(blockLibrary),
  };
};

export const shouldDisablePendingMenuRowInteractions = ({
  menuOnly = false,
  isPendingSectionBlock = false,
  isOffline = false,
  isMoveInFlight = false,
} = {}) => {
  if (!menuOnly || !isPendingSectionBlock) return false;
  return isOffline || isMoveInFlight;
};
